<template><div><h1 id="ergebnistabelle" tabindex="-1"><a class="header-anchor" href="#ergebnistabelle"><span>Ergebnistabelle</span></a></h1>
<p>Ergebnistabelle — Definiert eine Ergebnistabelle für eine Reportingtoolauswertung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Eine Ergebnistabelle definiert, welche Grösse bei einer Reportingtool Auswertung berechnet und gezeigt wird. In der Sprache von OLAP entspricht die Ergebnistabelle einem Measure.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Reporting-Tool</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Tabelle</dt>
<dd>Nummer der Ergebnistabelle innerhalb einer Reportingtool Auswertung.</dd>
<dt>E-Cd</dt>
<dd>Referenziert einen Ergebniswert aus <a class="xref" href="ft.refdata.tblrtresult.html" title="Ergebniswert"><span class="refentrytitle">Ergebniswert</span></a>.</dd>
<dt>Bezeichnung</dt>
<dd>Anzeige der Bezeichnung des Ergebniswerts aus <a class="xref" href="ft.refdata.tblrtresult.html" title="Ergebniswert"><span class="refentrytitle">Ergebniswert</span></a>.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/reportingtool.html" title="9. Reportingtool">Reportingtool</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblrtresult.html" title="Ergebniswert">Ergebniswerte</RouteLink></p>
</div></template>


